import Vue from 'vue';
import Vuetify, {VIcon, VTooltip, VBtn} from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
  components: { VIcon, VTooltip, VBtn },
});

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
});
